import { createSlice } from '@reduxjs/toolkit';
import { parseResponse } from '@skynet/data-ws-core';
import type { JsonLogSuccess, LogsState } from 'src/store/shared/log/types';
import { LogsCommand } from 'src/store/shared/log/types';
import { actionOnMessage } from '@skynet/data-ws-mm';
import { listen as listenLoans } from 'src/store/loans/actions';
import { listen as listenRetainers } from 'src/store/retainers/actions';
import { adminListen } from '@skynet/data-admin-listen';

export const initialState: LogsState = {
  error: null,
  requestStatus: null,
  list: [],
};

const allowedCommands = Object.values(LogsCommand);

const Logs = createSlice({
  name: 'logs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listenLoans, (state, action) => {
      const { isInitCall } = action.meta;
      if (isInitCall) {
        state.requestStatus = 'pending';
        state.list = [];
      }
    });

    builder.addCase(listenRetainers, (state, action) => {
      const { isInitCall } = action.meta;
      if (isInitCall) {
        state.requestStatus = 'pending';
        state.list = [];
      }
    });

    builder.addCase(adminListen, (state, action) => {
      const { isInitCall } = action.meta;
      if (isInitCall) {
        state.requestStatus = 'pending';
        state.list = [];
      }
    });

    builder.addCase(actionOnMessage, (state, action) => {
      const { json, skipProcessing, error } = parseResponse(action.payload, allowedCommands);

      if (skipProcessing || !json) return;

      console.debug(`logs/processing ${actionOnMessage.toString()}`, action, allowedCommands);

      if (error) {
        state.error = error;
        return;
      }

      const { command } = json;

      if (command === LogsCommand.Log) {
        const { list } = json as JsonLogSuccess;
        state.list = list;
        state.requestStatus = 'success';
      }
    });
  },
});

export const actionLogs = { ...Logs.actions };

export default Logs.reducer;
